module.exports = __webpack_public_path__ + "media/images/recipes/vega_jackfruit_burger-22bd20645d7d83d94d6369e4c51b57aa.pdf";